import { useState } from 'react';
export const useAccordionState = ({ initialState, onChange, }) => {
    const [isOpenStates, setIsOpenStates] = useState(initialState);
    const toggle = (index) => {
        setIsOpenStates((prevState) => {
            return prevState.map((oldState, i) => {
                if (i === index) {
                    const newState = !oldState;
                    onChange === null || onChange === void 0 ? void 0 : onChange(index, newState);
                    return newState;
                }
                return oldState;
            });
        });
    };
    return {
        isOpenStates,
        toggle,
    };
};
//# sourceMappingURL=useAccordionState.js.map